/* eslint-disable no-use-before-define */
import { useCallback, useState } from "react";
import { checkCustomMeasurements, getEndpointProductSupportBySwan, setupCTADisplay, storeSubscriptionCheck } from "../utils/Utils";
import UseApiService from "../services/apiService";
import posthog from "posthog-js";

// hooks/useSwanCTA.ts
export const useSwanCTA = ({ attributesData, setShowButton, setComponentToShow, setLoading,details }) => {
	 const [isCustom,setIsCustom] = useState(false);
     const [isOnboadedRTW,setIsOnboadedRTW] = useState(false)
	 const [isOnboadedTryon,setIsOnboadedTryon] = useState(false)
	const { shopDomain, product, callbackUrl, name } = attributesData ?? {};

	const handleSetupCustomBtn = useCallback(async (details) => {
		try {
			const res = await checkCustomMeasurements({ scanID:details?.scanID, shopDomain, productHandle: product?.handle, result: "", email:details?.email, name, shopifyRedirectUrl:details?.shopifyRedirectUrl, callbackUrl });
			setComponentToShow(res);
		} catch (error) {
			console.log(error, "error");
		}finally{
			setLoading(false);
		}
	}, [callbackUrl, name, product?.handle, setComponentToShow, setLoading, shopDomain]);

	const commonSetup =useCallback( async ({isOnboadedTryon,isOnboadedRTW,details}) => {
		console.log(details,"details");
		
		const res = await setupCTADisplay({
			productHandle: product?.handle,
			shopDomain,
			scanID:details?.scanID,
			email:details?.email,
			isOnboadedRTW,
			isOnboadedTryon
		});		
		setComponentToShow(res)
		setLoading(false)
	},[ product?.handle, setComponentToShow, setLoading, shopDomain]);
	
	const checkProductEligibilty=useCallback(async(details)=>{
		const endpoint = getEndpointProductSupportBySwan({ productHandle: product?.handle, shopDomain });
		try {
			const response = await UseApiService.get({ url: endpoint });
			const { isOnboadedRTW, isOnboadedTryon } = response?.data;
			setIsOnboadedTryon(isOnboadedTryon)
			setIsOnboadedRTW(isOnboadedRTW)
			posthog.capture(`${shopDomain}/product_request`, {
				productHandle: product?.handle,
				isOnboadedRTW,
				isOnboadedTryon,
			});
			if (isOnboadedRTW || isOnboadedTryon) {
				await commonSetup({ isOnboadedTryon, isOnboadedRTW,details });
			} else {
				setShowButton(false);
				setLoading(false)
			}
		} catch (error) {
			console.log(error);
			setShowButton(false);
			setLoading(false)
		}
	},[commonSetup, product?.handle, setLoading, setShowButton, shopDomain])
	
	const setupSwanCTA = useCallback(
		async (custom,details) => {
			if (custom) {
				handleSetupCustomBtn(details);
				return;
			}
			checkProductEligibilty(details)
		},
		[checkProductEligibilty, handleSetupCustomBtn],
	);
	const checkAndSetupCTA = useCallback(async (details) => {
		console.log(details,"inside check setup");
		
		try {
			const custom = await storeSubscriptionCheck(shopDomain);			
			setIsCustom(custom);
			setupSwanCTA(custom,details);
		} catch (error) {
			setShowButton(false);
		}
	}, [shopDomain, setupSwanCTA, setShowButton]);

	const hideSwanButton = useCallback(
		(reason) => {
			console.log(reason, "error reason");
			setShowButton(false);
		},
		[setShowButton],
	);
	return {
		setupSwanCTA,
		checkAndSetupCTA,
		isCustom,
		hideSwanButton,
		isOnboadedRTW,
		isOnboadedTryon
	};
};
